// extracted by mini-css-extract-plugin
export var container = "_16-0";
export var icon = "_16-1";